/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react";
import ScaleRuler from "./ScaleRuler";

/**
 * StepsSlider Component Props
 */
export interface StepsSliderProps {
  defaultValue?: number;
  onChange?: (value: number) => void;
}

/**
 * StepsSlider Component
 * A component for setting daily step goals using the fixed ScaleRuler
 */
const StepsSlider: React.FC<StepsSliderProps> = ({
  defaultValue = 7500, // Start at 0 by default
  onChange = () => {},
}) => {
  // Format steps with K notation
  const formatSteps = (value: number): string => {
    if (value === 0) return "0 steps";
    if (value >= 1000) {
      const valueInK = value / 1000;
      return Number.isInteger(valueInK)
        ? `${valueInK}K steps`
        : `${valueInK.toFixed(1)}K steps`;
    }
    return `${value} steps`;
  };

  // Format labels with K notation
  const formatLabel = (value: number): string => {
    if (value === 0) return "0";
    if (value >= 1000) {
      const valueInK = value / 1000;
      return Number.isInteger(valueInK) ? `${valueInK}K` : `${valueInK.toFixed(1)}K`;
    }
    return value.toString();
  };

  return (
    <ScaleRuler
      minValue={0}
      maxValue={18150}
      value={defaultValue}
      step={100}
      majorStep={1000}
      minorStep={500}
      labelInterval={1000}
      width={320}
      height={80}
      tickSpacing={10}
      activeColor="#7BD2EC"
      borderColor="#7BD2EC"
      formatValue={formatSteps}
      formatLabel={formatLabel}
      onChange={onChange}
      displayLabel="Daily step goal"
      // helperText="Drag to set your daily step goal"
    />
  );
};

export default StepsSlider;
